import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [expended, setExpended] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsTermsOpen(false);
  };

  const [isTermsDropdownOpen, setIsTermsDropdownOpen] = useState(false);





  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setIsMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const dropdownRef = useRef(null);

  return (
    <>
      <header className="z-40 sticky-header main-bar-wraper navbar-expand-lg duretion-500">
        <div className="main-bar">
          <div className="container">
            <div className="bottom-bar">
              <div className="two-bar">
                <div className="flex items-center justify-between">
                  <div className="logo">
                    <a href="/">
                      <img alt="logo" src="assets/img/logo.png" className="w-[200px]" />
                    </a>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  const nav = document.getElementById("mobile-nav");
                  const isNowOpen = nav.classList.toggle("open");
                  setIsMenuOpen(isNowOpen);
                }}
                className="menu-start text-2xl lg:hidden"
                aria-label="Toggle Menu"
              >
                <i className={`fa-solid ${isMenuOpen ? "fa-xmark" : "fa-bars"}`}></i>
              </button>
              <nav className="navbar lg:block hidden">
                <ul className="navbar-links">
                  <li className="navbar-dropdown">
                    <a href="/" >Home</a>
                  </li>
                  <li className="navbar-dropdown">
                    <a href="/plans">Plans</a>
                  </li>
                  <li className="navbar-dropdown">
                    <a href="/fitness-videos">Fitness Videos</a>
                  </li>
                  <li className="navbar-dropdown menu-item-children">
                    <Link to="#" >Terms & Policies <i className="fa-solid fa-chevron-down"></i></Link>
                    <ul className="sub-menu">
                      <li>
                        <a href="/term-of-use">Term & Conditions</a>
                      </li>
                      <li>
                        <a href="/shipping-delivery-policy">Shipping And Delivery Policy</a>
                      </li>
                      <li>
                        <a href="/privacy-policy">Privacy Policy</a>
                      </li>
                      <li>
                        <a href="/cancellation-policy">Cancellation Policy</a>
                      </li>
                    </ul>
                  </li>
                  <li className="navbar-dropdown menu-item-children">
                    <Link to="#" >Resources <i className="fa-solid fa-chevron-down"></i></Link>
                    <ul className="sub-menu">
                      <li>
                        <a href="/career">Career</a>
                      </li>
                      <li>
                        <a href="/refer-and-earn">Refer and Earn</a>
                      </li>
                      <li>
                        <a href="/contact">Contact Us</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>

              <nav className="navbar lg:block hidden">
                <ul className="navbar-links">
                  <li className="navbar-dropdown menu-item-children">
                    <div className="header-menu-right">
                      <a href="login.html" target="_blank" className="btn xl:block hidden">
                        <span>
                          Login
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                      </a>
                    </div>
                    <ul className="sub-menu w-[200px] mt-2">
                      <li>
                        <a href="/login.html" target="_blank">Customer Login</a>
                      </li>
                      {/* <li>
                        <a href="https://portal.curepointopd.in/" target="_blank">Leader Login</a>
                      </li> */}
                      <li>
                        <a href="https://portal.curepointopd.in/" target="_blank">Partner's Login</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          {/* Mobile Nav */}
          <div className="mobile-nav" id="mobile-nav">
            <div className="res-log mb-30">
              <a href="/">
                <img alt="logo" src="assets/img/logo.png" className="w-[200px]" />
              </a>
            </div>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/plans">Plans</a></li>
              <li><a href="/fitness-videos">Fitness Videos</a></li>
              <li className={`menu-item-has-children ${isTermsDropdownOpen ? 'active' : ''}`}>
                <button
                  onClick={() => setIsTermsDropdownOpen(!isTermsDropdownOpen)}
                  className="w-full text-left flex justify-between items-center"
                >
                  <span>Terms & Policies</span>
                  <i className={`fa-solid fa-chevron-${isTermsDropdownOpen ? 'up' : 'down'}`}></i>
                </button>

                {isTermsDropdownOpen && (
                  <ul className="sub-menu">
                    <li><a href="/term-of-use">Terms & Conditions</a></li>
                    <li><a href="/shipping-delivery-policy">Shipping & Delivery Policy</a></li>
                    <li><a href="/privacy-policy">Privacy Policy</a></li>
                    <li><a href="/cancellation-policy">Cancellation Policy</a></li>
                  </ul>
                )}
              </li>


              <li><a href="/career">Career</a></li>
              <li><a href="/refer-and-earn">Refer and Earn</a></li>
              <li><a href="/contact">Contact</a></li>
              <li>
                <a href="/login.html"  target="_blank" className="flex justify-between items-center">
                  Customer Login
                  <svg
                    className="w-6 h-6 ml-8 -mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://portal.curepointopd.in/" target="_blank" className="flex justify-between items-center">
                  Partner's Login
                  <svg
                    className="w-6 h-6 ml-8 -mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </a>
              </li>
              {/* <li>
                <a href="https://portal.curepointopd.in/" target="_blank" className="flex justify-between items-center">
                  Agent Login
                  <svg
                    className="w-6 h-6 ml-8 -mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </a>
              </li> */}
            </ul>
          </div>

        </div>
      </header>
    </>
  );
};

export default Header;
